import React from "react";
import { Modal, Tag, Button, Row, Col, Divider } from "antd";
import { useSelector } from "react-redux";
import { formatDateToDMY, formatTime12Hour, formatEventType } from "../../utils/tools";
import { Icon } from "@iconify/react/dist/iconify.js";

const EventViewModal = ({ open, onClose, data, onStatusChange }) => {
    const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
    if (!data) return null;
    console.log(data)

    const getStatusColor = (status) => {
        switch (status) {
            case "accepted":
                return "green";
            case "rejected":
                return "red";
            case "new":
            default:
                return "blue";
        }
    };

    const Item = ({ label, value }) => (
        <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                {label}
            </div>
            <div style={{ fontSize: 15, fontWeight: 500, wordBreak: "break-word" }}>
                {value || "-"}
            </div>
        </div>
    );

    return (
        <Modal
            title="Event Details"
            open={open}
            onCancel={onClose}
            width={700}
            centered
            footer={
                viewPermissions.includes("event.edit") ? (
                    [
                        <Button
                            key="reject"
                            danger
                            disabled={data.status === "rejected"}
                            onClick={() => onStatusChange(data.id, "rejected")}
                        >
                            Reject
                        </Button>,
                        <Button
                            key="accept"
                            type="primary"
                            disabled={data.status !== "new"}
                            onClick={() => onStatusChange(data.id, "accepted")}
                        >
                            Accept
                        </Button>,
                    ]
                ) : null
            }
        >
            <Row gutter={[16, 10]}>

                {/* <Col xs={24} sm={12}>
                    <Item label="Diocese" value={data.parish?.diocese?.name} />
                </Col>

                <Col xs={24} sm={12}>
                    <Item label="Parish" value={data.parish?.parish_name} />
                </Col> */}

                <Col xs={24} sm={12}>
                    <Item
                        label="Event Title"
                        value={formatEventType(data.event_type?.name ?? data.event_type_others)}
                    />
                </Col>

                <Col xs={24} sm={12}>
                    <Item label="Church Name" value={data.church?.name} />
                </Col>

                <Col xs={24} sm={12}>
                    <Item label="Latitude" value={data.church?.latitude} />
                </Col>

                <Col xs={24} sm={12}>
                    <div style={{ marginBottom: 16 }}>
                        <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                            Longitude
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: 15, fontWeight: 500 }}>{data.church?.longitude || "-"}</span>
                            {data.church?.latitude && data.church?.longitude && (
                                <a
                                    href={`https://www.google.com/maps/search/?api=1&query=${data.church.latitude},${data.church.longitude}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'flex', alignItems: 'center' }}
                                >
                                    <Icon
                                        icon="logos:google-maps"
                                        width="20"
                                        height="20"
                                    />
                                </a>
                            )}
                        </div>
                    </div>
                </Col>

                <Col xs={24} sm={12}>
                    <Item
                        label="Start Date"
                        value={
                            data.start_datetime
                                ? `${formatDateToDMY(data.start_datetime)} ${formatTime12Hour(data.start_datetime)}`
                                : "-"
                        }
                    />
                </Col>


                <Col xs={24} sm={12}>
                    <Item
                        label="End Date"
                        value={
                            data.end_datetime
                                ? `${formatDateToDMY(data.end_datetime)} ${formatTime12Hour(data.end_datetime)}`
                                : "-"
                        }
                    />
                </Col>


                {data.is_recurring && (
                    <Col xs={24} sm={12}>
                        <Item
                            label="Recurring Type"
                            value={
                                (!data.recurring_type || data.recurring_type === "none") && !data.recurring_pattern
                                    ? "-"
                                    : `${formatEventType(data.recurring_type) || "-"} / ${formatEventType(data.recurring_pattern) || "-"}`
                            }
                        />
                    </Col>
                )}



                <Col xs={24} sm={12}>
                    <div style={{ marginBottom: 16 }}>
                        <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                            Status
                        </div>
                        <Tag color={getStatusColor(data.status)}>
                            {data.status?.toUpperCase()}
                        </Tag>
                    </div>
                </Col>

                <Col xs={24} sm={12}>
                    <div style={{ marginBottom: 16 }}>
                        <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                            Created By
                        </div>
                        <Tag color="gray">
                            {data.created_by?.type?.toUpperCase()}
                        </Tag>{" "}
                        {data.created_by?.name}
                    </div>
                </Col>

                <Col xs={24} sm={12}>
                    <div style={{ marginBottom: 16 }}>
                        <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                            Updated By
                        </div>
                        <Tag color="gray">
                            {data.updated_by_admin?.type?.toUpperCase()}
                        </Tag>{" "}
                        {data.updated_by_admin?.name}
                    </div>
                </Col>

                <Col xs={24} sm={12}>
                    <div style={{ marginBottom: 16 }}>
                        <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                            User Event Count
                        </div>
                        <Tag color="blue">
                            {data.user?.festivals_count ?? 0}
                        </Tag>
                    </div>
                </Col>

            </Row>

            <Divider />

            <div>
                <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                    Details
                </div>
                <div style={{ fontSize: 15 }}>
                    {data.details || "-"}
                </div>
            </div>

        </Modal>
    );
};

export default EventViewModal;